<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <!-- .el-cascader-node>.el-radio -->
        <el-select v-model='thePostId' clearable placeholder='请选择岗位' size='small' @change="postChange">
          <el-option v-for="item in postAll" :key="item.postId" :label="item.postName" :value="item.postId">
          </el-option>
        </el-select>
        <el-select v-model='theYutId' clearable placeholder='请选择类型' size='small' @change="yutChange">
          <el-option v-for="item in getUserTypeList_data.data || []" :key="item.yutId" :label="item.yutName"
            :value="item.yutId">
          </el-option>
        </el-select>
        <el-select v-model='theDtId'  clearable placeholder="请选择战队" @change="getData" size='small'>
          <el-option v-for="item in getDepartmentList_data.data || []" :key="item.dtId" :label="item.dtName"
            :value="item.dtId">
          </el-option>
        </el-select>
        <el-input v-model="getUserList_data.userName" placeholder="请输入用户名" clearable size='small'
          style="max-width:260px;margin-left:10px;" />
        <el-input v-model="getUserList_data.userPhone" placeholder="请输入手机号" clearable size='small'
          style="max-width:260px;margin-left:10px;" />

        <el-button v-click.getUserList type="primary" icon='el-icon-search' size='small' style='margin-left:10px;'>搜索
        </el-button>
        <el-button v-if='exportProjectStsState ' @click="out"
          size='small' type="primary" style="float:right" icon='el-icon-circle-plus'>导出用户数据
        </el-button>
      </el-col>
      <el-col :span="6">
        <el-button v-if='addUserProject && theDepartment && (theDepartment.dtLevel == 4)' @click="$form('addUserExcel')"
          size='small' type="primary" style="float:right" icon='el-icon-circle-plus'>批量添加
        </el-button>
        <el-button v-if='addUserProject' @click="$form('addUserProject'), getPostList(), getRoleList()" size='small'
          type="primary" style="float:right" icon='el-icon-circle-plus'>添加账号
        </el-button>
      </el-col>
    </el-row>

    <mytable :tableColums='tableColums_getUserList' api='getUserList' xupdateapi='updateUser' :height="H - 165">
      <icol slot='openid' slot-scope='{row}' class='fCenter'>
        <span v-show="row.postId == 5 && row.openid">已绑定</span>
        <span v-show="row.postId == 5 && !row.openid" style="color: orange;">未绑定</span>
      </icol>
      <icol slot='openidAi' slot-scope='{row}' class='fCenter'>
        <span v-show="row.postId == 5 && row.openidAi">已绑定</span>
        <span v-show="row.postId == 5 && !row.openidAi" style="color: orange;">未绑定</span>
      </icol>
    </mytable>

    <myform :viewobj='{
        addUserProject: ["新增账号信息", "el-icon-circle-plus"],
        updateUser: ["修改账号信息", "el-icon-edit-outline"],
        $succeed$: getUserList
      }' @close='$form("updateUser", "reset")'>

      <!-- 岗位id -->
      <template v-slot:postId="{ Myformdata }">
        <el-select v-model='Myformdata.postId' clearable>
          <el-option v-for="item in getPostList_data.data || []" :key="item.postId" :label="item.postName"
            :value="item.postId">
          </el-option>
        </el-select>
      </template>
      <!-- 类型id -->
      <template v-slot:yutId="{ Myformdata }">
        <el-select v-model='Myformdata.yutId' clearable>
          <el-option v-for="item in getUserTypeList_data.data || []" :key="item.yutId" :label="item.yutName"
            :value="item.yutId">
          </el-option>
        </el-select>
      </template>

      <!-- 角色权限 -->
      <template v-slot:roleListString="{ Myformdata }">
        <el-select v-model='Myformdata.roleListString' multiple clearable>
          <el-option v-for="item in getRoleList_data.data || []" :key="item.roleId" :label="item.roleName"
            :value="item.roleId">
          </el-option>
        </el-select>
      </template>
      <!-- 角色权限 -->
      <template v-slot:dtId="{ Myformdata }">
        <el-select v-model='Myformdata.dtId'  clearable>
          <el-option v-for="item in getDepartmentList_data.data || []" :key="item.dtId" :label="item.dtName"
            :value="item.dtId">
          </el-option>
        </el-select>
      </template>


      <template v-slot:loginApp="{ Myformdata }">
        <el-radio v-model="Myformdata.loginApp" :label='1'>是</el-radio>
        <el-radio v-model="Myformdata.loginApp" :label='2'>否</el-radio>
      </template>
      <template v-slot:loginPc="{ Myformdata }">
        <el-radio v-model="Myformdata.loginPc" :label='1'>是</el-radio>
        <el-radio v-model="Myformdata.loginPc" :label='2'>否</el-radio>
      </template>
      <template v-slot:targetJs="{ Myformdata }">
        <el-input v-model="Myformdata.targetJs" type="number" placeholder="可再次输入签约总家数..."></el-input>
      </template>
      <template v-slot:targetJe="{ Myformdata }">
        <el-input v-model="Myformdata.targetJe" type="number" placeholder="可再次输入签约总金额..."></el-input>
      </template>
      <template v-slot:targetSl="{ Myformdata }">
        <el-input v-model="Myformdata.targetSl" type="number" placeholder="可再次输入签约总数量..."></el-input>
      </template>
      <template v-slot:userVisitorTargetCount="{ Myformdata }">
        <el-input v-model="Myformdata.userVisitorTargetCount" type="number" placeholder="可再次输入每日走访目标..."></el-input>
      </template>
      <template v-slot:userOrderMoneyTarget="{ Myformdata }">
        <el-input v-model="Myformdata.userOrderMoneyTarget" type="number" placeholder="可再次输入每日签单目标..."></el-input>
      </template>
      <!-- 隐藏指定字段 -->
      <hide slot='userId' />
    </myform>

    <myform :viewobj='{
        updateUserVisitorTargetCount: ["设置每日走访目标", "el-icon-edit-outline"],
        $succeed$: getUserList
      }' @close='$form("updateUserVisitorTargetCount", "reset")'>
      <hide slot='userId' />
    </myform>
    <myform :viewobj='{
        updateUserOrderMoneyTarget: ["设置每日开单金额", "el-icon-edit-outline"],
        $succeed$: getUserList
      }' @close='$form("updateUserOrderMoneyTarget", "reset")'>
      <hide slot='userId' />
    </myform>
  </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    return {
      theDtId:'',
      baseUrl: $Api.baseUrl_online,
      yuvbId: null,
      yuvbcId: null,
      yuvbIds: [],
      userId: null,
      Userinfo: {},
      thePostId: "",
      theDepartment: {},
      postAll: [
        { postId: 5, postName: "学员" },
        { postId: 2, postName: "战队管理" }
      ],
      theYutId: "",
      tableColums_getUserList: {
        $selection: false,

        dtName: ['部门'],
        userName: ['用户名',120],
        userAccount: ['工号', 120],
        userPhone: ['手机号', 120],
        // userMail: '邮箱',
        // department: [ '岗位', , '@text: {{ $row.post && $row.post.postName }}' ],
        postId: ['岗位', 80, '@v-if: 1:平台管理, 2:战队管理, 3:项目经理, 4:老师, 5:学员, 6:项目管理员'],
        yutName: ['类型', 80],
        roleNames: ['角色', 80],
        userVisitorTargetCount: ['每日走访目标', 100,
          this.updateUserVisitorTargetCount && `@text: {{ $row.userVisitorTargetCount ||'' + ' 设置' }}#success
            @v-if: $row.postId == 5
            @click: $form("updateUserVisitorTargetCount",$row)
            `,
        ],
        userOrderMoneyTarget: ['每日开单金额目标', 100,
          this.updateUserOrderMoneyTarget && `@text: {{ $row.userOrderMoneyTarget ||'' + ' 设置' }}#success
            @v-if: $row.postId == 5
            @click: $form("updateUserOrderMoneyTarget",$row)
            `,
        ],
        // loginLastTime: ['最后登录时间|sortable', 150],
        createtime: ['创建时间|sortable', 150],
        // openid: ["赢销驻手", 100,],
        openidAi: ["赢销AI练", 100,],
        $operation: (this.updateUser || this.deleteUser) && [
          '操作', 200,

          this.updateUser && `@text: 编辑#success
           @v-if: $row.postId == 5 || $row.postId == 2
           @click: $form("updateUser",$row), getPostList(), getRoleList()
          `,

          this.deleteUser && `@text: 删除#danger
           @v-if: $row.postId == 5 || $row.postId == 2
           @click: _confirm('确定要删除该账号吗?')
                   .trigger('deleteUser',{userListString:$row.userId+""})
                   .trigger('getUserList')
          `,
          this.resetUserPassword && `@text: 重置密码#danger
           @click: _confirm('确定要重置该账号密码吗?')
                   .trigger('resetUserPassword',{userId:$row.userId})
                   .trigger('getUserList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    out(){
      this.openLoading();
        var that = this
        axios({
          method: 'post',
          url: that.baseUrl + '/opportunity/user/exportProjectStsState',
          data: '',
          withCredentials: true,
          timeout: 1200000,
          responseType: 'arraybuffer',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            'token': A.local('$Usertoken'),
            'projectId': +A.local('$projectId'),
          }
        }).then(function (res) {
          if (res.data) {
            that.loading.close();
            let a = document.createElement('a');
            //ArrayBuffer 转为 Blob
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", '用户.xlsx');
            a.click();
            that.$message({
              message: "成功",
              type: "success"
            });
          }
        })
    },
    handleClose() {
      this.yuvbcId = null;
      this.yuvbIds = [];
    },
    addBuilding() {
      const yuvbIds = this.yuvbIds.toString()
      this.addUserVisitorBuildingUserRelationsByUser({ userId: this.userId, yuvbIds });
      this.yuvbcId = null;
      this.yuvbIds = [];
    },
    getUserBuilding(row) {
      this.BuildingVisible = true;
      this.userId = row.userId
      this.getUserVisitorBuildingUserListByUser({ userId: row.userId })

    },
    getBuildingList(e) {
      console.log(e);
      this.getUserVisitorBuildingList({ yuvbcId: e });
    },
    yutChange(e) {
      this.theYutId = e;
      this.getData();
    },
    postChange(e) {
      this.thePostId = e;
      this.getData();
    },
    getData() {
      this.getUserList({ currentPage: 1, pageSize: 10, postId: this.thePostId, yutId: this.theYutId,dtId:this.theDtId });
    }
  },

  created() {
    this.Userinfo = $Parse(localStorage.getItem("$Userinfo"));
    this.theDepartment = this.Userinfo.department;
    this.getUserList({ currentPage: 1, pageSize: 10 });
    this.getUserTypeList({ pageSize: 0, });
    this.getDepartmentList()
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/User/UserManage.keepAlive.vue